import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import ModalBtns from '@groovehq/internal-design-system/lib/components/ModalBtns/ModalBtns'
import Drawer from '@groovehq/internal-design-system/lib/components/Drawer/UnmanagedDrawer'
import HeaderWithImage from '@groovehq/internal-design-system/lib/components/HeaderWithImage/HeaderWithImage'
// Should be this:
import image from '@groovehq/internal-design-system/lib/assets/images/users.png'

import { bool } from 'prop-types'
import { doCreateInvitations } from 'ducks/agents/operations'

import { yupResolver } from '@hookform/resolvers/yup'
import { isValidEmail } from 'util/strings'
import * as yup from 'yup'

import { useForm } from 'react-hook-form'
import AddBulk from './AddBulk'

const BULK_FORM_SCHEMA = yup.object().shape({
  bulkEmails: yup.string(),
})

const AgentAddDrawer = props => {
  const { open, onClose, setSendMode } = props

  const dispatch = useDispatch()

  const formSchema = BULK_FORM_SCHEMA

  const {
    handleSubmit,
    formState: { isValid },
    reset,
    setValue,
    getValues,
  } = useForm({
    mode: 'all',
    resolver: yupResolver(formSchema),
    defaultValues: {
      bulkRole: 'agent',
      bulkEmails: '',
    },
  })

  const handleOnClose = useCallback(
    () => {
      const closeOptions = {}
      onClose(closeOptions)
    },
    [onClose]
  )

  const onSubmit = useCallback(
    data => {
      const { bulkEmails, bulkRole } = data
      const users = []
      bulkEmails.split(',').forEach(rawEmail => {
        const email = rawEmail.trim()
        if (email && isValidEmail(email)) {
          users.push({
            email,
            role: bulkRole,
          })
        }
      })
      if (users.length > 0) {
        dispatch(doCreateInvitations(users))
      }
      handleOnClose()
    },
    [dispatch, handleOnClose]
  )

  const handleRoleChange = useCallback(
    key => {
      reset()
      setValue('bulkRole', key)
    },
    [reset, setValue]
  )

  const DrawerForm = useCallback(
    subprops => <form onSubmit={handleSubmit(onSubmit)} {...subprops} />,
    [handleSubmit, onSubmit]
  )

  const footer = (
    <ModalBtns
      saveBtnDisabled={!isValid}
      saveBtnText="Invite to Groove"
      // type="submit" will automatically trigger the form submit event when clicked
      saveBtnHtmlType="submit"
      tertiaryBtnText="Cancel"
      onClickTertiaryBtn={onClose}
    />
  )
  return (
    <Drawer
      title="Add a team member"
      open={open}
      onClose={onClose}
      footer={footer}
      container={DrawerForm}
    >
      <HeaderWithImage
        imgWidth="120px"
        img={image}
        title="Bulk invite via email..."
        intro="Add each email on a new line or separated by comma."
        className="grui mb-14"
      />{' '}
      <AddBulk
        setSendMode={setSendMode}
        role={getValues('bulkRole')}
        handleRoleChange={handleRoleChange}
        setValue={setValue}
      />
    </Drawer>
  )
}

AgentAddDrawer.propTypes = {
  open: bool.isRequired,
}

AgentAddDrawer.defaultProps = {}

export default AgentAddDrawer
